// extracted by mini-css-extract-plugin
export default {"keyboard":"styles_keyboard__n8mBN","row":"styles_row__bWCpC","secondRow":"styles_secondRow__dcsRl","defaultRow":"styles_defaultRow__hspth"};